export const draftjs = {
  blocks: [
    {
      text: "",
      type: "unstyled"
    }
  ],
  entityMap: {}
};
